import React from "react";
import { FaBuilding, FaUser, FaCalendarAlt, FaTools, FaEye } from "react-icons/fa";
import dayjs from "dayjs";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import DetailPerBangunan from "./DetailPerBangunan";
import Edit from "../action/Edit";
import Hapus from "../action/Hapus";

function formatDate(value) {
  if (!value) return "-";
  const date = dayjs(value);
  return date.isValid() ? date.format("DD/MM/YYYY") : "-";
}

function DataPerBangunan({
  currentData,
  handleDelete,
  handleEdit,
  getStatusBadge,
  getStatusIcon,
  openDetailModal,
  isDetailModalOpen,
  closeDetailModal,
  selectedItem,
  loading = false,
}) {
  return (
    <>
    <DataTable
      value={currentData}
      paginator
      rows={10}
      rowsPerPageOptions={[5, 10, 25, 50]}
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      currentPageReportTemplate="Menampilkan {first} sampai {last} dari {totalRecords} data"
      emptyMessage="Tidak ada data perawatan bangunan"
      loading={loading}
      stripedRows
      showGridlines
      responsiveLayout="scroll"
      sortField="tgl_masuk"
      sortOrder={-1}
      className="p-datatable-sm"
    >
      <Column
        field="nama_bagian"
        header="Bagian"
        body={(row) => (
          <div className="flex items-center">
            <FaBuilding className="mr-2 text-gray-400" />
            <span className="text-sm font-medium text-gray-900">{row.nama_bagian || "-"}</span>
          </div>
        )}
        style={{ minWidth: "160px" }}
        sortable
      />
      <Column
        field="jenis_kerusakan"
        header="Jenis Kerusakan"
        body={(row) => (
          <div className="flex items-center">
            <FaTools className="mr-2 text-gray-400" />
            <span className="text-sm text-gray-900">{row.jenis_kerusakan || "-"}</span>
          </div>
        )}
        style={{ minWidth: "160px" }}
        sortable
      />
      <Column
        field="pic"
        header="Petugas"
        body={(row) => (
          <div className="flex items-center">
            <FaUser className="mr-2 text-gray-400" />
            <span className="text-sm text-gray-900">{row.pic || "-"}</span>
          </div>
        )}
        style={{ minWidth: "140px" }}
        sortable
      />
      <Column
        field="tgl_masuk"
        header="Tanggal Masuk"
        body={(row) => (
          <div className="flex items-center">
            <FaCalendarAlt className="mr-2 text-gray-400" />
            <span className="text-sm text-gray-900">{formatDate(row.tgl_masuk)}</span>
          </div>
        )}
        style={{ minWidth: "160px" }}
        sortable
      />
      <Column
        field="status"
        header="Status"
        body={(row) => (
          <span className={getStatusBadge(row.status)}>
            {getStatusIcon(row.status)}
            {row.status || "-"}
          </span>
        )}
        style={{ minWidth: "130px" }}
        sortable
      />
      <Column
        header="Aksi"
        body={(row) => (
          <div className="flex items-center gap-2">
            <button
              type="button"
              title="Lihat Detail"
              onClick={() => openDetailModal(row.id)}
              className="rounded-lg p-2 text-blue-600 transition-colors hover:bg-blue-50 hover:text-blue-900"
            >
              <FaEye />
            </button>
            <Edit id={row.id} handleEdit={handleEdit} />
            <Hapus id={row.id} handleDelete={handleDelete} />
          </div>
        )}
        style={{ minWidth: "140px" }}
        sortable={false}
      />
    </DataTable>
    <DetailPerBangunan
      showTrigger={false}
      openDetailModal={openDetailModal}
      isDetailModalOpen={isDetailModalOpen}
      closeDetailModal={closeDetailModal}
      selectedItem={selectedItem}
      getStatusBadge={getStatusBadge}
      getStatusIcon={getStatusIcon}
    />
    </>
  );
}

export default DataPerBangunan;
